import { tv } from 'tailwind-variants';

export const button = tv({
  base: 'flex flex-row gap-2 items-center h-[30px] rounded-[64px] text-brand-color-primary-lighter text-center justify-center px-3 py-1',
  variants: {
    variant: {
      primary:
        'bg-[linear-gradient(95.27deg,_#6B89C3_-38.36%,_#1B229F_95.05%)] text-button-color-primary-default',
      secondary: 'bg-card-color-default text-color-brand-primary ',
      outline:
        'border-hairline border-mono-color-medium text-color-brand-primary border-color-brand-primary',
    },
    error: {
      true: '',
    },
    disabled: {
      true: 'cursor-not-allowed',
    },
  },
  compoundVariants: [
    {
      variant: 'primary',
      error: true,
      className: 'bg-[#CE4E69] text-mono-color-lightest',
    },
    {
      variant: 'secondary',
      error: true,
      className: 'text-[#CE4E69] border-mono-color-lightest',
    },
    {
      variant: 'outline',
      error: true,
      className: 'border-[#CE4E69] text-[#CE4E69]',
    },
    {
      variant: 'primary',
      disabled: true,
      className: 'bg-color-medium text-mono-color-dark',
    },
  ],
});
